import { RefundFormDictionary } from 'types/i18n';

export const refundFormDictionaryRu: RefundFormDictionary = {
  amountInputLabel: 'Сумма возврата, $',
  commentInputLabel: 'Комментарий к возврату для клиента',
};
